import React from "react";
import Hero from "../components/Hero";
import Content from "../components/Content";
import SocialFollow from "../SocialFollow";
import { Icon, InlineIcon } from '@iconify/react';
import whatsappIcon from '@iconify/icons-mdi/whatsapp';


function AboutPage(props){

    return(
        <div>
            <Hero title={props.title} />

            <Content>
                <p>I am a Full-Stack Engineer with experience in React, Angular, NodeJS, EmberJS, Flutter, Python, PHP, Java, C#, VB.Net, Firebase, MongoDB, MySQL, SQL, Web Development, WordPress, Drupal, and a host of other programming languages and mobile frameworks.</p>
                <p>My extensive use of modern day JavaScript frameworks such as React, Flutter, Vue has given me a real appreciation of their features such as reusable code, great performance, and their robustness. Starting my journey in software development in high school with Pascal i have come a long way to graduating through the various programming languages available. </p>
                <p>I graduated from the University of South Africa after enrolling in Informatics. I also graduated from Oracle's Database Administration program as well as Cloud server technologies. I continue to invest my time in the education of the latest technologies so that i can always be in a position to be up-to-date with the latest systems in the world, and be in a position to develop these systems from scratch. </p>
                <p>I constantly continue to develop both mobile and desktop applications that run on cross-platforms, and also engage in imparting useful software engineering principles to a host of individuals and organizations, including under-privileged children(something i like to call "catch them while still young". Meaning why wait for them to get to university level.Rather teach them programming at an early age) </p>
                <SocialFollow /> <ul>tafadzwamunyuki@gmail.com</ul>              
                <Icon icon={whatsappIcon} /> +263775375088
            </Content>
            
        </div>
    )
}

export default AboutPage;